import { storyblokEditable } from '@storyblok/react/rsc';
import { FC, Fragment } from 'react';
import { ContentAccordionStoryblok } from 'storyblok-types';
import { H4, P } from 'atoms/Typography';
import { Accordion } from 'molecules/Accordion';
import { RichTextMarkdown } from 'pages/StoryBlok/RichText';
import { useTranslations } from 'modules/i18n/useTranslations';
import styles from 'src/client/components/pages/StoryBlok/ContentAccordion/styles.module.css';

export const ContentAccordion: FC<{ blok: ContentAccordionStoryblok }> = ({
  blok,
}) => {
  const t = useTranslations();

  return (
    <Fragment {...storyblokEditable(blok)}>
      {blok.content?.map((item, i) => (
        <Accordion
          key={item._uid}
          classes={{
            bareRoot: styles.root,
            summaryRoot: styles.summary,
            details: styles.details,
          }}
          summaryContent={t(
            `content.accordion.numbering.${blok.listNumbering || 'none'}`,
            {
              headline: item.headline || '',
              index: i + 1,
            },
          )}
          invertArrow
        >
          <RichTextMarkdown
            className={styles.text}
            text={item.content}
            components={{
              p: ({ children }) => <P className={styles.p}>{children}</P>,
              h4: ({ children }) => <H4 className={styles.h4}>{children}</H4>,
            }}
          />
        </Accordion>
      ))}
    </Fragment>
  );
};
